import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiClient } from '../services/apiClient'

export default function OwnerLoginPage() {
  const navigate = useNavigate()
  
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  })
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')

    try {
      const response = await apiClient.post('/owner/login', {
        username: formData.username,
        password: formData.password,
      })
      
      if (response.access_token) {
        // Очищаем токены админа если есть
        localStorage.removeItem('admin.access_token')
        localStorage.removeItem('admin.email')
        localStorage.removeItem('admin.full_name')
        localStorage.removeItem('admin.hotel_name')
        
        // Сохраняем токен владельца
        localStorage.setItem('owner_token', response.access_token)
        localStorage.setItem('owner_username', response.username)
        
        setSuccess('✅ Вход успешен! Перенаправление...')
        
        setTimeout(() => {
          navigate('/owner/dashboard')
        }, 1000)
      } else {
        setError('Ошибка: не получен токен от сервера')
      }
    } catch (err: any) {
      setError('Неверные учетные данные')
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-indigo-600 p-4">
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-full max-w-md">
          <div className="bg-white shadow-2xl rounded-lg p-6 sm:p-8">
            <div className="text-center mb-6 sm:mb-8">
              <h1 className="text-2xl sm:text-3xl font-bold text-purple-600 mb-2">👑 HotelCheck</h1>
              <p className="text-gray-600 text-xs sm:text-sm">Вход владельца системы</p>
            </div>

            {error && (
              <div className="mb-4 sm:mb-6 bg-red-50 border border-red-200 text-red-700 px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-xs sm:text-sm">
                ⚠️ {error}
              </div>
            )}

            {success && (
              <div className="mb-4 sm:mb-6 bg-green-50 border border-green-200 text-green-700 px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-xs sm:text-sm">
                {success}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Логин
                </label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Пароль
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm sm:text-base"
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-purple-600 text-white py-2 sm:py-3 rounded-lg font-semibold hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition text-sm sm:text-base touch-manipulation"
              >
                {isLoading ? '⏳ Вход...' : '🔐 Войти'}
              </button>

              <button
                type="button"
                onClick={() => navigate('/')}
                className="w-full text-purple-600 text-xs sm:text-sm hover:text-purple-700 transition mt-2 touch-manipulation"
              >
                ← На главную
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
